
import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import { IAlipayUnitBankAccountAddRequest, IAlipayUnitBankAccountDetail, IAlipayUnitBankAccountListItem, IAlipayUnitBankAccountRequest, IAlipayUnitBankAccountUpdateParam, IAlipayUnitDetail, IAlipayUnitPageRequest, IAlipayUnitWithdrawRequest } from '@core/main/types';

const hostUrl = getHostbaseUrl();

/**
 * 支付宝管理 -来账账户分页
 */
export async function queryAlipayUnitBankAccountPage(params: IAlipayUnitBankAccountRequest) {
  let total = 0;
  let data = [] as IAlipayUnitBankAccountDetail[];

  try {
    const { code, context, message } = await Http.get<{ data: IAlipayUnitBankAccountDetail[]; total: number }>(
      `${hostUrl}/pay/alipay-unit-bank-account/page`,
      { ...params },
    );

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || {} as { data: IAlipayUnitBankAccountDetail[]; total: number };

      data = res.data || [];
      total = res.total || 0;

      data.forEach((item) => {
      });
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 支付宝管理 -记账本列表
 */
export async function queryAlipayUnitList(params: { serverId: string }) {
  let data = [] as any[];

  try {
    const { code, context, message } = await Http.get<any>(
      `${hostUrl}/pay/alipay-unit/list`,
      { ...params },
    );

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || {} as any;

      data = res || [];

    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return { data };
}

/**
 * 支付宝管理 -新增来账账户
 */
export async function addUnitBankAccount(param: IAlipayUnitBankAccountAddRequest) {

  param = JSON.parse(JSON.stringify(param)) as IAlipayUnitBankAccountAddRequest;

  try {
    const { code, message } = await Http.post<any>(`${hostUrl}/pay/alipay-unit-bank-account/add`, param);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * 支付宝管理 -批量更新来账账户状态
 */
export async function updateUnitBankAccount(param: IAlipayUnitBankAccountUpdateParam) {

  param = JSON.parse(JSON.stringify(param)) as IAlipayUnitBankAccountUpdateParam;

  try {
    const { code, message } = await Http.post<any>(`${hostUrl}/pay/alipay-unit-bank-account/update`, param);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * 支付宝管理 -删除来账账户
 */
export async function deleteUnitBankAccount(param: {id: number}) {

  param = JSON.parse(JSON.stringify(param)) as { id: number };

  try {
    const { code, message } = await Http.post<any>(`${hostUrl}/pay/alipay-unit-bank-account/delete`, param);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * 支付宝记账簿银行账户导出
 * @param params 参数
 */
export async function exportAlipayUnitBankAccount(params: IAlipayUnitBankAccountRequest) {
  let buffer = null as Blob | null;
  let fileName = ''; // 默认文件名

  try {
    const { code, context, message, headers } = await Http.get<Blob>(
      `${hostUrl}/pay/alipay-unit-bank-account/export`,
      params,
      { responseType: 'blob' },
    );

    if (headers['content-disposition']) {
      const match = headers['content-disposition'].match(/filename=(.+);?/);

      if (match && match[1]) {
        fileName = decodeURIComponent(match[1].trim().replace(/"/g, ''));
      }
    }

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    buffer,
    fileName,
  };
}

/**
 * 支付宝管理 -支付宝记账簿分页
 */
export async function queryAlipayUnitPage(params: IAlipayUnitPageRequest) {
  let total = 0;
  let data = [] as IAlipayUnitDetail[];

  try {
    const { code, context, message } = await Http.get<{ data: IAlipayUnitDetail[]; total: number }>(
      `${hostUrl}/pay/alipay-unit/page`,
      { ...params },
    );

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || {} as { data: IAlipayUnitDetail[]; total: number };

      data = res.data || [];
      total = res.total || 0;

      data.forEach((item) => {
      });
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 支付宝记账簿银行账户导出
 * @param params 参数
 */
export async function exportAlipayUnit(params: IAlipayUnitPageRequest) {
  let buffer = null as Blob | null;
  let fileName = ''; // 默认文件名

  try {
    const { code, context, message, headers } = await Http.get<Blob>(
      `${hostUrl}/pay/alipay-unit/export`,
      params,
      { responseType: 'blob' },
    );

    if (headers['content-disposition']) {
      const match = headers['content-disposition'].match(/filename=(.+);?/);

      if (match && match[1]) {
        fileName = decodeURIComponent(match[1].trim().replace(/"/g, ''));
      }
    }

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    buffer,
    fileName,
  };
}

/**
 * 支付宝管理 -重新申请来账账户
 */
export async function reapplyUnitBankAccount(param: IAlipayUnitBankAccountAddRequest) {

  param = JSON.parse(JSON.stringify(param)) as IAlipayUnitBankAccountAddRequest;

  try {
    const { code, message } = await Http.post<any>(`${hostUrl}/pay/alipay-unit-bank-account/reapply`, param);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * 支付宝管理 -获取来账账户详细信息
 */
export async function queryAlipayUnitBankAccountDetail(param: { bankAccountId: number }) {
  let data = {} as any;

  try {
    const { code, context, message } = await Http.get<any>(
      `${hostUrl}/pay/alipay-unit-bank-account/detail`,
      { ...param },
    );

    if (code === EAxiosResponseCode.Succeed) {
      data = context || {} as any;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 支付宝管理 -支付宝记账来账账户列表
 */
export async function queryAlipayUnitBankAccountList(params: any) {
  let data = [] as IAlipayUnitBankAccountListItem[];

  try {
    const { code, context, message } = await Http.get<any>(
      `${hostUrl}/pay/alipay-unit-bank-account/list`,
      { ...params },
    );

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || [] as IAlipayUnitBankAccountListItem[];

      data = res || [];

    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return { data };
}

/**
 * 支付宝管理 -支付宝账簿提现
 */
export async function withdrawAlipayUnit(param: IAlipayUnitWithdrawRequest) {

  try {
    const { code, message } = await Http.post<any>(`${hostUrl}/pay/alipay-unit/withdraw`, param);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}